import { IAtomicCondition } from 'types/flows';
import { conditionKeys, OperatorTypes } from './AtomicCondition/constants';
import { AtomicChangeInitType, IOnConditionChange } from './types';

type IAtomicConditions = {
	atomicConditions: IAtomicCondition[];
};

interface IResetValueMethod extends IOnConditionChange {
	type: AtomicChangeInitType;
	val: string;
	taskIndex: number;
	condIndex: number;
	values: {
		taskConditions: Array<IAtomicConditions>;
	};
}

export const getResetValue = ({
	type: initType,
	val: toKey,
	taskIndex,
	condIndex,
	values
}: IResetValueMethod) => {
	const { predicate, target } =
		values.taskConditions[taskIndex].atomicConditions[condIndex];
	const { value: predicateValue } = predicate;

	if (initType === AtomicChangeInitType.operator) {
		const { value: targetValue } = target;

		if (!targetValue) {
			return predicateValue;
		}

		const { type, options } = conditionKeys.filter(
			({ name }) => name === targetValue
		)[0];

		if (OperatorTypes.multiple.includes(toKey)) {
			if (typeof predicateValue === 'string') {
				const split = predicateValue.trim().split(',');
				if (options && split.length) {
					const optLabels = options.map((l) => l.label);
					const optValues = options.map((l) => l.value);
					const hasOption = split
						.filter((s) => optLabels.includes(s) || optValues.includes(s))
						.filter(Boolean);
					if (!hasOption.length) {
						return [];
					}
					return hasOption;
				}
				return [];
			}

			if (Array.isArray(predicateValue)) {
				return predicateValue;
			}

			return [];
		}

		if (type === 'string') {
			if (typeof predicateValue === 'string') {
				return predicateValue;
			}

			if (Array.isArray(predicateValue)) {
				return predicateValue[0];
			}

			return '';
		}

		if (type === 'number') {
			if (typeof Number(predicateValue) === 'number') {
				return Number(predicateValue);
			}

			return 0;
		}

		if (type === 'boolean') {
			return false;
		}

		return predicateValue;
	}

	if (initType === AtomicChangeInitType.target) {
		const { type: targetType, options: typeOptions } = conditionKeys.filter(
			({ name }) => name === toKey
		)[0];

		if (
			targetType === 'string' &&
			typeof predicateValue === 'string' &&
			typeOptions &&
			predicateValue.length
		) {
			const labels = typeOptions.map((l) => l.label);
			const hasOption = labels.includes(predicateValue.trim());
			return hasOption ? predicateValue : '';
		}

		if (
			targetType === 'string' &&
			Array.isArray(predicateValue) &&
			typeOptions &&
			predicateValue.length
		) {
			const labels = typeOptions.map((l) => l.label);
			const hasOptions = predicateValue
				.filter((v) => labels.includes(v))
				.filter(Boolean);
			return hasOptions;
		}

		if (targetType === typeof predicateValue) {
			return predicateValue;
		}

		if (targetType === 'string') {
			return '';
		}

		if (targetType === 'number') {
			return 0;
		}

		if (targetType === 'boolean') {
			return false;
		}

		return predicateValue;
	}

	return predicateValue;
};
